export const API_ServerAddress: string='http://api.ferdoslab.com/';